import { blocks } from '@yola/ws-sdk';

function getParentBlockByElement(element) {
  if (!element) return null;

  return element.closest(`[id^=${blocks.constants.BLOCK_ID_PREFIX}]`);
}

export default getParentBlockByElement;
